import styles from "./About.module.css";
import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const feedbacks = [
  {
    name: "Vinya Sharma",
    role: "Advanced Oil Painting Student",
    text: "Nupur Creations transformed how I see light and shadow. The personalized guidance is unlike any other art school I've attended.",
    avatar: "🎨",
  },
  {
    name: "Shalini yadav",
    role: "Sketching Enthusiast",
    text: "The environment here is so nurturing. I went from drawing stick figures to detailed portraits in just six months!",
    avatar: "✏️",
  },
  {
    name: "Anita Rao",
    role: "Parent of Junior Artist",
    text: "My daughter looks forward to every Saturday. The way Nupur explains complex techniques to kids is truly magical.",
    avatar: "🌟",
  },
];

const AboutPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1 === feedbacks.length ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? feedbacks.length - 1 : prev - 1));
  };
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.aboutContainer}>
        {/* SECTION 1: HERO INTRO */}
        <section className={styles.heroSection}>
          <div className={styles.heroText}>
            <h1 className={styles.mainHeading}>
              Unleash Your <br />
              Creativity{" "}
              <span className={styles.accentText}>
                One <br />
                Brushstroke at a Time!
              </span>
            </h1>
            <div className={styles.underline}></div>
          </div>
          <div className={styles.heroDescription}>
            <p>
              Welcome to Nupur Creations, where creativity meets passion! At
              Nupur Creations, we believe that art is more than just colors on a
              canvas—it's a journey of self-expression, imagination, and
              skill-building. Whether you are a beginner exploring your artistic
              side or an experienced artist looking to refine your techniques,
              our school offers a nurturing environment where you can grow and
              thrive.
            </p>
            <p>
              Our mission is to inspire, educate, and empower artists of all
              ages. We strive to provide high-quality art education that fosters
              creativity, confidence, and technical excellence in every student.
            </p>
          </div>
        </section>
        {/* SECTION 2: THE STORY & GRID */}
        <section className={styles.storySection}>
          <div className={styles.storyContent}>
            <h2 className={styles.sectionHeading}>
              We Offering <br /> top-quality <br />
              <span className={styles.accentText}>Art Courses</span>
            </h2>
            <div className={styles.storyText}>
              <p>
                After completing her 7th-year Senior Diploma in Fine Art from
                the prestigious Lalit Kala Academy in India, Nupur embarked on a
                journey to share her passion for art with a broader audience.
                Upon arriving in the United States, she nurtured a vision—one
                that would not only teach art but also inspire creativity,
                innovation, and self-expression among both children and adults.
              </p>
              <p>
                Nupur Creations was born—a space dedicated to mentoring aspiring
                artists, guiding learners of all ages, and helping individuals
                tap into their creative potential. More than just an art school,
                Nupur Creations is a platform that encourages students to think
                beyond conventional techniques, to experiment fearlessly, and to
                develop their unique artistic voices.With a curriculum that
                blends traditional fine art principles with modern, exploratory
                approaches, Nupur Creations fosters an environment where
                creativity has no limits. Whether it's drawing, painting, mixed
                media, or digital art, students are encouraged to extend their
                innovations, embrace challenges, and see the world through the
                eyes of an artist.At its core, Nupur Creations is about more
                than just art—it’s about nurturing imagination, building
                confidence, and transforming ideas into masterpieces. Whether
                you are a beginner looking to explore your artistic side or an
                experienced artist seeking new inspiration, this school is a
                creative sanctuary where everyone can grow, learn, and thrive.
              </p>
            </div>
          </div>
          <div className={styles.collageGrid}>
            <img
              src="/assets/imgs/gallery/collage_final.jpeg"
              alt="Faculty Art portraits"
            />
          </div>
        </section>
        {/* SECTION 3: OUR VALUES */}
        <section className={styles.valuesSection}>
          <div className={styles.valuesHeader}>
            <div className={styles.blueLine}></div>
            <span className={styles.valuesTitle}>
              <span className={styles.accentText}>Our Values</span>
            </span>
            <div className={styles.blueLine}></div>
          </div>
          <div className={styles.valuesGrid}>
            <div className={styles.valueCard}>
              <div className={styles.iconBox}>🎨</div>
              <h3>Personalized Learning</h3>
              <p>
                Tailored guidance for every student, from beginners to advanced
                artists.
              </p>
            </div>
            <div className={styles.valueCard}>
              <div className={styles.iconBox}>🧠</div>
              <h3>Experienced Instructor/s</h3>
              <p>
                Learn from professional artists with years of teaching
                experience.
              </p>
            </div>
            <div className={styles.valueCard}>
              <div className={styles.iconBox}>🎓</div>
              <h3>Diverse Art Programs</h3>
              <p>
                Explore painting, drawing, digital art, and mixed media
                techniques.
              </p>
            </div>
            <div className={styles.valueCard}>
              <div className={styles.iconBox}>🚀</div>
              <h3>Inspiring Community</h3>
              <p>
                A creative space to connect, collaborate, and grow as an artist.
              </p>
            </div>
          </div>
        </section>
        // Inside your AboutPage return statement, below the Values section:
        <section className={styles.feedbackSection}>
          <div className={styles.feedbackHeader}>
            <h2 className={styles.sectionHeading}>
              Voices of our <br />{" "}
              <span className={styles.accentText}>Creative Community</span>
            </h2>
          </div>

          <div className={styles.carouselContainer}>
            {/* Navigation Buttons */}
            <button
              className={styles.carouselBtn}
              onClick={prevSlide}
              aria-label="Previous"
            >
              <ChevronLeft size={32} />
            </button>

            <div className={styles.carouselWindow}>
              <div
                className={styles.carouselTrack}
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {feedbacks.map((item, index) => (
                  <div key={index} className={styles.carouselSlide}>
                    <div className={styles.feedbackCard}>
                      <div className={styles.quoteIcon}>“</div>
                      <p className={styles.feedbackText}>{item.text}</p>
                      <div className={styles.studentInfo}>
                        <div className={styles.avatar}>{item.avatar}</div>
                        <div>
                          <h4 className={styles.studentName}>{item.name}</h4>
                          <span className={styles.studentRole}>
                            {item.role}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              className={styles.carouselBtn}
              onClick={nextSlide}
              aria-label="Next"
            >
              <ChevronRight size={32} />
            </button>
          </div>

          {/* Pagination Dots */}
          <div className={styles.dotsContainer}>
            {feedbacks.map((_, i) => (
              <div
                key={i}
                className={`${styles.dot} ${
                  currentIndex === i ? styles.activeDot : ""
                }`}
                onClick={() => setCurrentIndex(i)}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
